import type { ApplePayButton } from '#types/components/checkout/applePayButton'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    button: 'py-2'
  },
  icon: {
    width: 58
  },
  variant: 'secondary',
} satisfies RecursivePartial<ApplePayButton>
